import "bootstrap/dist/css/bootstrap.min.css";
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/lib/integration/react';
import { store, persistor} from './store';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
import { Router } from 'react-router-dom';
import history from './history';
import { getProductConfig } from './backend/productConfig';

// Browser-tab title: the cloud viewer sets a product viewerName ("Dividia Cloud"), so the tab reads
// that instead of the generic index.html "DVS Lite Viewer". Local/eview leave viewerName null and keep
// the static title. Resolved once at startup from REACT_APP_PRODUCT_MODE (the cloud build bakes =cloud).
// (#86bc2p0fh)
const productViewerName = getProductConfig().viewerName;
if (productViewerName) document.title = productViewerName;

ReactDOM.render(
  <Provider store={store}>
    <PersistGate persistor={persistor}> {/* loading={<LoadingView />}  */}
      <Router history={history}>
        <App />
      </Router>
    </PersistGate>
  </Provider>,
  document.getElementById('root')
);

// The viewer requires a live NVR for every useful screen, so offline precaching
// has no product value. More importantly, a registered CRA service worker can
// keep an old viewer container visible until every browser client exits. Keep
// it unregistered; the viewer image also ships a one-time reset worker at the
// legacy URL so already-registered installations clear their old caches.
serviceWorker.unregister();
